<template>
    <div id="addressList">
        <nav-bar>
            <div slot="left">
                <van-icon name="arrow-left" color="#666666" size="20" @click="goBack"/>
            </div>
            <div slot="title" style="font-weight: 800; font-size: 16px; ">{{langText.addressAdministration}}</div>
        </nav-bar>
        <van-address-list
                v-model="chosenAddressId"
                :list="list"
                :default-tag-text="langText.default"
                :add-button-text = "addButtonName"
                @add="onAdd"
                @edit="onEdit"
        />
    </div>
</template>

<script>
    import {Toast, AddressList, Icon} from 'vant'
    import NavBar from "@/components/common/navbar/NavBar";
    import {getUserAddressList} from "@/network/mine/mine";

    import { langPackage } from "@/config/lang/addressEditLang";
    import { selectLang } from "@/config/setLanguage";

    export default {
        name: "AddressList",
        components: {
            [AddressList.name]: AddressList,
            [Toast.name]: Toast,
            [Icon.name]: Icon,

            NavBar: NavBar
        },
        data() {
            return {
                chosenAddressId: '0',
                addButtonName: '添加地址',
                list: [],
                disabledList: [
                    {   //示例代码
                        id: '3',
                        name: '王五',
                        tel: '1320000000',
                        address: '浙江省杭州市滨江区江南大道 15 号',
                    },
                ],
                lang:"cn",
                langText:{},
                commonText:{},
            }
        },
        methods: {
            onAdd() {
                let status = this.$route.query.lastSource;
                if(status == 'noSubmitOrder'){
                    this.$router.push({
                        path: '/order/goodsOrder',
                        query: {
                            selectId: this.chosenAddressId
                        }
                    })
                }else {
                    this.$router.push({
                        path: '/mine/addressEdit',
                        name: 'AddressEdit',
                    })
                }
            },
            onEdit(item, index) {
                let status = this.$route.query.lastSource;
                    this.$router.push({
                        path: '/mine/addressEdit',
                        name: 'AddressEdit',
                        query: {
                            id: item.id,
                            status: status
                        }
                    })
            },
            goBack(){ //回退操作
                //如果是订单点击修改地址 则回退上一级
                if (this.$route.query.lastSource == 'noSubmitOrder'){
                    this.$router.back(-1);
                }
                this.$router.push({ path: '/mine'});
            },
        },
        created(){
            if(this.$route.query.lastSource == 'noSubmitOrder'){
                this.addButtonName = '确认'
            }

            //获取语言包
            selectLang(langPackage).then(langtxt =>{
                this.langText = langtxt.langtxt;
                this.commonText = langtxt.common;
                this.addButtonName = this.langText.addAddress
            });

            getUserAddressList().then(res => {
                for (let i = 0; i < res.data.length; i++) {
                    let addressDefaultStatus = res.data[i]['defaultStatus'] ? true : false;
                    if(addressDefaultStatus == true){
                        this.chosenAddressId = res.data[i]['id'];
                    }

                    this.list.push({
                        id: res.data[i]['id'],
                        name: res.data[i]['name'],
                        tel: res.data[i]['phoneNumber'],
                        address: res.data[i]['province'] + res.data[i]['city'] + res.data[i]['region'] + res.data[i]['detailAddress'],
                        isDefault: addressDefaultStatus,
                    })
                }
            })
        },
    }
</script>

<style scoped>
    @import "~@/assets/css/index/style.css";


    .van-address-list {
        margin-top: 47px;
    }

    .van-nav-bar {
        box-shadow: 0px 1px 3px 0px rgba(0,0,0,.5);
        background-color: #ffffff;
    }
</style>
